
import WTooltip from '../w-tooltip/w-tooltip.vue'

export default {
  components: {
    WTooltip,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    span: {
      type: Number,
      default: 1,
    },
    tooltipText: {
      type: String,
      default: null,
    },
  },
  methods: {
    hasValue() {
      return (
        this.$slots.default &&
        this.$slots.default.some((item) => !!item.tag || item.text.match(/\S/))
      )
    },
  },
}
